


























































import { Component, namespace, Prop, Vue } from 'nuxt-property-decorator'
import { mdiCheck } from '@mdi/js'
import { IProduct, IProductToCart } from '~/assets/interfaces/products'
import { filterUrl } from '~/assets/filters/url'
import { CART_PATH } from '~/assets/config/path'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import ComponentPrice from '~/components/price/price.vue'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentProductItem2 from '~/components/products/product-item-2.vue'

const cartStore = namespace('cart')

export interface IProductSetItem extends IProduct {
  active?: boolean
  finalPrice: number
}

@Component({
  components: {
    ComponentHeaderWithLink,
    ComponentPrice,
    ComponentFormButton,
    ComponentProductItem2,
    ComponentIcon,
  },
})
export default class ComponentProductSet extends Vue {
  @cartStore.Action('toCart') public toCart!: (
    product: IProductToCart[]
  ) => Promise<void>

  @Prop({ type: Array, default: [] }) readonly items!: IProductSetItem[]

  private isLoadingToCart = false
  private isInCart = false
  private ids: number[] = []
  private mdiCheck = mdiCheck
  private mainId = -1

  private get sum() {
    let temp = 0
    this.items.forEach((item: IProductSetItem) => {
      if (this.isActive(item.id)) {
        temp = temp + item.finalPrice * item.quantity
      }
    })
    return temp
  }

  public get buttonBuyText() {
    return this.isInCart ? 'В корзине' : 'В корзину'
  }

  private created() {
    this.ids = this.items.map((item) => {
      return item.id
    })
    this.mainId = this.ids[0]
  }

  private get qtyById(): Record<number, number> {
    return this.items.reduce((acc, it) => {
      const q = Number((it as any).quantity)
      acc[it.id] = Number.isFinite(q) && q > 0 ? Math.floor(q) : 1
      return acc
    }, {} as Record<number, number>)
  }

  private getQuantity(id: number): number {
    return this.qtyById[id] ?? 1
  }

  private async buy() {
    this.isLoadingToCart = true
    if (this.isInCart) {
      await this.$router.push(filterUrl(CART_PATH))
    } else {
      const idsTemp = this.ids.map((item) => {
        return {
          id: item,
          quantity: this.getQuantity(item),
        }
      })
      await this.toCart(idsTemp)
    }
    this.isLoadingToCart = false
    this.isInCart = true
  }

  private isActive(id: number) {
    return this.ids.includes(id)
  }

  private toggle(id: number) {
    if (this.mainId !== id) {
      if (this.isActive(id)) {
        this.ids = this.ids.filter((item) => item !== id)
      } else {
        this.ids.push(id)
      }
    }
  }
}
